module.exports = __webpack_public_path__ + "img/accessory_item_02.65076c8e.svg";